// アプリケーションのバージョン情報
export const APP_VERSION = '1.1.1'

// バージョン情報オブジェクト
export const versionInfo = {
  version: APP_VERSION,
}

